import './category-two-column.html.twig';
import './category-two-column.scss';